export default __webpack_public_path__ + "static/media/achievement-2.56c38889.jpg";